import { render, staticRenderFns } from "./getSMSLinkList.vue?vue&type=template&id=050512ee&scoped=true&"
import script from "./getSMSLinkList.vue?vue&type=script&lang=js&"
export * from "./getSMSLinkList.vue?vue&type=script&lang=js&"
import style0 from "./getSMSLinkList.vue?vue&type=style&index=0&id=050512ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050512ee",
  null
  
)

export default component.exports